import { stringify as uuidStringify } from 'uuid';
import CryptoBrowserify from 'crypto-browserify';

// TX Builder cannot fetch transformations data for entries without signature which is calculated basing on transformation name
// as temp solution we can calculate it on client-side before proper solution in backend - signature property returned to client
// TODO: eslint-disable can be removed once eslint is updated or globals for ES6 are on (BigInt global)
export const calculateSignature = (transformationName) => {
  const UUID3_MASK = 0xc0004000000000000000;
  const UUID3_BITS = 0x30008000000000000000;

  const bytesArray = CryptoBrowserify.createHash('md5').update(transformationName).digest();

  const result = bytesArray.reduce((acc, value) => BigInt(acc << BigInt(8)) + BigInt(value), BigInt(0));

  const bytesValue = (result & ~BigInt(UUID3_MASK)) | BigInt(UUID3_BITS);
  const hexRaw = bytesValue.toString(16);
  const hex = hexRaw.length % 2 ? `0${hexRaw}` : hexRaw;
  const bytesArrayFromHex = new Uint8Array(hex.match(/.{1,2}/g).map((v) => parseInt(v, 16)));

  return uuidStringify(bytesArrayFromHex);
};
